import logo from './imgs/tmLogo.png';
import ukLogo from './imgs/mymyndlogo.png';

const { REACT_APP_STAGE } = process.env;

export const getLogo = () => {
  return REACT_APP_STAGE === 'uk' ? ukLogo : logo;
};
